import { normalizeBoolean } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_STARFISH_PETITION_KICKSTART_TOGGLE = createFcmConfig('starfish_petition_kickstart_toggle', {
	normalizer: normalizeBoolean,
	defaultValue: false,
});
